import {
  MERCADOPAGO,
  MERCADOPAGO_ERROR,
  CLEAN_MERCADOPAGO,
  CLEAN_MERCADOPAGO_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function mercadoPagoReducer(state = initialState, action) {
  switch (action.type) {
    case MERCADOPAGO:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case MERCADOPAGO_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_MERCADOPAGO:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_MERCADOPAGO_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
